"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var proxy_exports = {};
__export(proxy_exports, {
  proxyHttpRequest: () => proxyHttpRequest,
  proxyWebSocket: () => proxyWebSocket
});
module.exports = __toCommonJS(proxy_exports);
var http = __toESM(require("http"), 1);
var net = __toESM(require("net"), 1);
function proxyHttpRequest(req, res, target) {
  var headers = {
    ...req.headers,
    "x-forwarded-host": req.headers.host
  };
  if (req.socket.remoteAddress) {
    headers["x-forwarded-for"] = req.socket.remoteAddress;
  }
  var options = {
    hostname: "localhost",
    port: target.port,
    path: req.url,
    method: req.method,
    headers
  };
  var proxyReq = http.request(options, function(proxyRes) {
    res.writeHead(proxyRes.statusCode || 500, proxyRes.headers);
    proxyRes.pipe(res);
  });
  proxyReq.on("error", function(err) {
    console.error(`[daemon] Proxy error to port ${target.port}:`, err.message);
    if (!res.headersSent) {
      res.writeHead(502);
      res.end(`Bad Gateway: ${err.message}`);
    }
  });
  req.pipe(proxyReq);
}
function proxyWebSocket(req, socket, head, target) {
  var proxySocket = net.connect(target.port, "localhost", function() {
    var reqLines = [
      `${req.method} ${req.url} HTTP/1.1`,
      ...Object.entries(req.headers).map(function(param) {
        var [k, v] = param;
        if (Array.isArray(v)) return `${k}: ${v.join(", ")}`;
        return `${k}: ${v}`;
      }),
      "",
      ""
    ];
    proxySocket.write(reqLines.join("\r\n"));
    if (head.length) {
      proxySocket.write(head);
    }
    socket.pipe(proxySocket);
    proxySocket.pipe(socket);
  });
  proxySocket.on("error", function(err) {
    console.error(`[daemon] WebSocket proxy error to port ${target.port}:`, err.message);
    socket.end();
  });
  socket.on("error", function(err) {
    console.error(`[daemon] Client socket error:`, err.message);
    proxySocket.end();
  });
  socket.on("close", function() {
    proxySocket.end();
  });
  proxySocket.on("close", function() {
    socket.end();
  });
}
//# sourceMappingURL=proxy.js.map
